import React from 'react';
import { Image } from 'antd';
import style from './LeftVisitorDetail.module.scss';
import ezconImg from '../../../../../public/ezcon.png';

export default function LeftVisitorDetail(detail) {
  const visitorDetails = detail.detail;
  const allowedFuncs = detail.allowedFuncs;
  let detailsArr = [
    { title: '來訪時間', data: visitorDetails.admissionTime },
    { title: '離開時間', data: visitorDetails.leaveTime },
    { title: '訪客姓名', data: visitorDetails.visitorsName },
    { title: '訪客電話', data: visitorDetails.visitorsPhone },
    { title: '訪客體溫', data: visitorDetails.temperature },
    { title: '訪客車牌', data: visitorDetails.carNumber },
    { title: '戶號', data: visitorDetails.householdNumber },
    { title: '戶號姓名', data: visitorDetails.residentName },
    { title: '拜訪原因', data: visitorDetails.visitingReason },
    { title: '訪客人數', data: visitorDetails.peopleNumber },
    { title: '訪客狀態', data: visitorDetails.visitorsStatus },
    { title: '訪客卡狀態', data: visitorDetails.takeCardStatus },
    {
      title: '訪客卡號',
      data: allowedFuncs.includes('訪客卡片管理')
        ? visitorDetails.cardNumber
        : visitorDetails.cardOrderNumber,
    },
  ];
  if (!allowedFuncs.includes('訪客卡片管理')) {
    detailsArr = [
      ...detailsArr,
      { title: '訪客卡片編號(自行命名)', data: visitorDetails.cardNumbering },
      { title: '卡片備註', data: visitorDetails.cardNotes },
    ];
  }

  return (
    <div className={style.detailContainer}>
      <div className={style.photos}>
        <div className={style.photoDiv}>
          <strong>訪客照片</strong>
          <Image
            src={visitorDetails.visitorPhoto || ezconImg}
            height={100}
            preview={false}
            style={{
              marginBottom: '0.5rem',
              border: '1px solid #d9d9d9',
            }}
          />
        </div>
        <div className={style.photoDiv}>
          <strong>證件照</strong>
          <Image
            src={visitorDetails.visitorRemarkPhoto || ezconImg}
            height={100}
            preview={false}
            style={{
              marginBottom: '0.5rem',
              border: '1px solid #d9d9d9',
            }}
          />
        </div>
      </div>
      <div className={style.details}>
        {detailsArr.map((item) => (
          <div>
            <strong>{item.title}</strong>
            <p>{item.data ? item.data : '無資料'}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
